module.exports = __webpack_public_path__ + "img/ld_1336.adeeaadf.png";